export const EMPTY_ELEMENT_PROPERTIES = {
  atomicMass: null,
  electronegativity: null,
  ionization: null,
  density: null,
  meltingPointK: null,
  boilingPointK: null,
  phaseAtSTP: null,
  occurrence: null,
  electronConfiguration: null,
  stableIsotopeCount: null,
  standardAtomicWeightNote: null,
  halfLife: null,
  decayMode: null,
  sourceRefs: null,
  sourceNotes: null,
  stable: null,
  discovered: null,
};

export const PROPERTY_SEEDS = {
  1: {
    sourceNotes: {
      electronConfiguration: "v2.6 limited first-18 seed batch; verify before treating as authoritative."
    },
    electronConfiguration: "1s1",
    atomicMass: 1.008,
    electronegativity: 2.2,
    ionization: 13.598,
    density: 0.00008988,
    phaseAtSTP: "gas",
    occurrence: "natural",
    sourceRefs: {
      atomicMass: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      electronConfiguration: [
        "rsc",
        "pubchem"
      ]
    },
    stable: true,
    discovered: 1766
  },
  2: {
    sourceNotes: {
      electronConfiguration: "v2.6 limited first-18 seed batch; verify before treating as authoritative."
    },
    electronConfiguration: "1s2",
    atomicMass: 4.0026,
    electronegativity: null,
    ionization: 24.587,
    density: 0.0001785,
    phaseAtSTP: "gas",
    occurrence: "natural",
    sourceRefs: {
      atomicMass: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      electronConfiguration: [
        "rsc",
        "pubchem"
      ]
    },
    stable: true,
    discovered: 1895
  },
  3: {
    electronConfiguration: "[He] 2s1",
    atomicMass: 6.94,
    electronegativity: 0.98,
    ionization: 5.392,
    density: 0.534,
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      atomicMass: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      electronConfiguration: [
        "rsc",
        "pubchem"
      ]
    },
    stable: true,
    discovered: 1817
  },
  4: {
    electronConfiguration: "[He] 2s2",
    atomicMass: 9.0122,
    electronegativity: 1.57,
    ionization: 9.323,
    density: 1.85,
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      atomicMass: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      electronConfiguration: [
        "rsc",
        "pubchem"
      ]
    },
    stable: true,
    discovered: 1798
  },
  5: {
    electronConfiguration: "[He] 2s2 2p1",
    atomicMass: 10.81,
    electronegativity: 2.04,
    ionization: 8.298,
    density: 2.34,
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      atomicMass: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      electronConfiguration: [
        "rsc",
        "pubchem"
      ]
    },
    stable: true,
    discovered: 1808
  },
  6: {
    electronConfiguration: "[He] 2s2 2p2",
    atomicMass: 12.011,
    electronegativity: 2.55,
    ionization: 11.26,
    density: 2.267,
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      atomicMass: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      electronConfiguration: [
        "rsc",
        "pubchem"
      ]
    },
    stable: true,
    discovered: -3750
  },
  7: {
    electronConfiguration: "[He] 2s2 2p3",
    atomicMass: 14.007,
    electronegativity: 3.04,
    ionization: 14.534,
    density: 0.001251,
    phaseAtSTP: "gas",
    occurrence: "natural",
    sourceRefs: {
      atomicMass: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      electronConfiguration: [
        "rsc",
        "pubchem"
      ]
    },
    stable: true,
    discovered: 1772
  },
  8: {
    electronConfiguration: "[He] 2s2 2p4",
    atomicMass: 15.999,
    electronegativity: 3.44,
    ionization: 13.618,
    density: 0.001429,
    phaseAtSTP: "gas",
    occurrence: "natural",
    sourceRefs: {
      atomicMass: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      electronConfiguration: [
        "rsc",
        "pubchem"
      ]
    },
    stable: true,
    discovered: 1774
  },
  9: {
    electronConfiguration: "[He] 2s2 2p5",
    atomicMass: 18.998,
    electronegativity: 3.98,
    ionization: 17.423,
    density: 0.001696,
    phaseAtSTP: "gas",
    occurrence: "natural",
    sourceRefs: {
      atomicMass: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      electronConfiguration: [
        "rsc",
        "pubchem"
      ]
    },
    stable: true,
    discovered: 1886
  },
  10: {
    sourceNotes: {
      electronConfiguration: "v2.6 limited first-18 seed batch; verify before treating as authoritative."
    },
    electronConfiguration: "[He] 2s2 2p6",
    atomicMass: 20.18,
    electronegativity: null,
    ionization: 21.565,
    density: 0.0009002,
    phaseAtSTP: "gas",
    occurrence: "natural",
    sourceRefs: {
      atomicMass: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      electronConfiguration: [
        "rsc",
        "pubchem"
      ]
    },
    stable: true,
    discovered: 1898
  },
  11: {
    electronConfiguration: "[Ne] 3s1",
    atomicMass: 22.99,
    electronegativity: 0.93,
    ionization: 5.139,
    density: 0.97,
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      atomicMass: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      electronConfiguration: [
        "rsc",
        "pubchem"
      ]
    },
    stable: true,
    discovered: 1807
  },
  12: {
    electronConfiguration: "[Ne] 3s2",
    atomicMass: 24.305,
    electronegativity: 1.31,
    ionization: 7.646,
    density: 1.738,
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      atomicMass: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      electronConfiguration: [
        "rsc",
        "pubchem"
      ]
    },
    stable: true,
    discovered: 1755
  },
  13: {
    electronConfiguration: "[Ne] 3s2 3p1",
    atomicMass: 26.982,
    electronegativity: 1.61,
    ionization: 5.986,
    density: 2.7,
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      atomicMass: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      electronConfiguration: [
        "rsc",
        "pubchem"
      ]
    },
    stable: true,
    discovered: 1825
  },
  14: {
    electronConfiguration: "[Ne] 3s2 3p2",
    atomicMass: 28.085,
    electronegativity: 1.9,
    ionization: 8.152,
    density: 2.3296,
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      atomicMass: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      electronConfiguration: [
        "rsc",
        "pubchem"
      ]
    },
    stable: true,
    discovered: 1824
  },
  15: {
    electronConfiguration: "[Ne] 3s2 3p3",
    atomicMass: 30.974,
    electronegativity: 2.19,
    ionization: 10.487,
    density: 1.823,
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      atomicMass: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      electronConfiguration: [
        "rsc",
        "pubchem"
      ]
    },
    stable: true,
    discovered: 1669
  },
  16: {
    electronConfiguration: "[Ne] 3s2 3p4",
    atomicMass: 32.06,
    electronegativity: 2.58,
    ionization: 10.36,
    density: 2.07,
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      atomicMass: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      electronConfiguration: [
        "rsc",
        "pubchem"
      ]
    },
    stable: true,
    discovered: -2000
  },
  17: {
    electronConfiguration: "[Ne] 3s2 3p5",
    atomicMass: 35.45,
    electronegativity: 3.16,
    ionization: 12.968,
    density: 0.0032,
    phaseAtSTP: "gas",
    occurrence: "natural",
    sourceRefs: {
      atomicMass: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      electronConfiguration: [
        "rsc",
        "pubchem"
      ]
    },
    stable: true,
    discovered: 1774
  },
  18: {
    sourceNotes: {
      electronConfiguration: "v2.6 limited first-18 seed batch; verify before treating as authoritative."
    },
    electronConfiguration: "[Ne] 3s2 3p6",
    atomicMass: 39.948,
    electronegativity: null,
    ionization: 15.76,
    density: 0.001784,
    phaseAtSTP: "gas",
    occurrence: "natural",
    sourceRefs: {
      atomicMass: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      electronConfiguration: [
        "rsc",
        "pubchem"
      ]
    },
    stable: true,
    discovered: 1894
  },
  19: {
    sourceNotes: {
      electronConfiguration: "v2.7 limited electron-configuration batch covering elements 19–36; verify before treating as authoritative."
    },
    electronConfiguration: "[Ar] 4s1",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  20: {
    sourceNotes: {
      electronConfiguration: "v2.7 limited electron-configuration batch covering elements 19–36; verify before treating as authoritative."
    },
    electronConfiguration: "[Ar] 4s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  21: {
    electronConfiguration: "[Ar] 3d1 4s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  22: {
    electronConfiguration: "[Ar] 3d2 4s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  23: {
    electronConfiguration: "[Ar] 3d3 4s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  24: {
    sourceNotes: {
      electronConfiguration: "v2.7 limited electron-configuration batch covering elements 19–36; verify before treating as authoritative."
    },
    electronConfiguration: "[Ar] 3d5 4s1",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  25: {
    electronConfiguration: "[Ar] 3d5 4s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  26: {
    electronConfiguration: "[Ar] 3d6 4s2",
    atomicMass: 55.845,
    electronegativity: 1.83,
    ionization: 7.902,
    density: 7.874,
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      atomicMass: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    },
    stable: true,
    discovered: -5000
  },
  27: {
    electronConfiguration: "[Ar] 3d7 4s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  28: {
    electronConfiguration: "[Ar] 3d8 4s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  29: {
    sourceNotes: {
      electronConfiguration: "v2.7 limited electron-configuration batch covering elements 19–36; verify before treating as authoritative."
    },
    electronConfiguration: "[Ar] 3d10 4s1",
    atomicMass: 63.546,
    electronegativity: 1.9,
    ionization: 7.726,
    density: 8.96,
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      atomicMass: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    },
    stable: true,
    discovered: -9000
  },
  30: {
    electronConfiguration: "[Ar] 3d10 4s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  31: {
    electronConfiguration: "[Ar] 3d10 4s2 4p1",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  32: {
    electronConfiguration: "[Ar] 3d10 4s2 4p2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  33: {
    electronConfiguration: "[Ar] 3d10 4s2 4p3",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  34: {
    electronConfiguration: "[Ar] 3d10 4s2 4p4",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  35: {
    electronConfiguration: "[Ar] 3d10 4s2 4p5",
    phaseAtSTP: "liquid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  36: {
    sourceNotes: {
      electronConfiguration: "v2.7 limited electron-configuration batch covering elements 19–36; verify before treating as authoritative."
    },
    electronConfiguration: "[Ar] 3d10 4s2 4p6",
    phaseAtSTP: "gas",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  37: {
    sourceNotes: {
      electronConfiguration: "v2.8 limited electron-configuration batch covering elements 37–54; verify before treating as authoritative."
    },
    electronConfiguration: "[Kr] 5s1",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  38: {
    sourceNotes: {
      electronConfiguration: "v2.8 limited electron-configuration batch covering elements 37–54; verify before treating as authoritative."
    },
    electronConfiguration: "[Kr] 5s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  39: {
    electronConfiguration: "[Kr] 4d1 5s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  40: {
    electronConfiguration: "[Kr] 4d2 5s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  41: {
    sourceNotes: {
      electronConfiguration: "v2.8 limited electron-configuration batch covering elements 37–54; verify before treating as authoritative."
    },
    electronConfiguration: "[Kr] 4d4 5s1",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  42: {
    sourceNotes: {
      electronConfiguration: "v2.8 limited electron-configuration batch covering elements 37–54; verify before treating as authoritative."
    },
    electronConfiguration: "[Kr] 4d5 5s1",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  43: {
    electronConfiguration: "[Kr] 4d5 5s2",
    phaseAtSTP: "solid",
    occurrence: "synthetic",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  44: {
    sourceNotes: {
      electronConfiguration: "v2.8 limited electron-configuration batch covering elements 37–54; verify before treating as authoritative."
    },
    electronConfiguration: "[Kr] 4d7 5s1",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  45: {
    sourceNotes: {
      electronConfiguration: "v2.8 limited electron-configuration batch covering elements 37–54; verify before treating as authoritative."
    },
    electronConfiguration: "[Kr] 4d8 5s1",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  46: {
    sourceNotes: {
      electronConfiguration: "v2.8 limited electron-configuration batch covering elements 37–54; verify before treating as authoritative."
    },
    electronConfiguration: "[Kr] 4d10",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  47: {
    sourceNotes: {
      electronConfiguration: "v2.8 limited electron-configuration batch covering elements 37–54; verify before treating as authoritative."
    },
    electronConfiguration: "[Kr] 4d10 5s1",
    atomicMass: 107.8682,
    electronegativity: 1.93,
    ionization: 7.576,
    density: 10.49,
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      atomicMass: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    },
    stable: true,
    discovered: -3000
  },
  48: {
    electronConfiguration: "[Kr] 4d10 5s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  49: {
    electronConfiguration: "[Kr] 4d10 5s2 5p1",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  50: {
    electronConfiguration: "[Kr] 4d10 5s2 5p2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  51: {
    electronConfiguration: "[Kr] 4d10 5s2 5p3",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  52: {
    electronConfiguration: "[Kr] 4d10 5s2 5p4",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  53: {
    electronConfiguration: "[Kr] 4d10 5s2 5p5",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  54: {
    sourceNotes: {
      electronConfiguration: "v2.8 limited electron-configuration batch covering elements 37–54; verify before treating as authoritative."
    },
    electronConfiguration: "[Kr] 4d10 5s2 5p6",
    phaseAtSTP: "gas",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  55: {
    electronConfiguration: "[Xe] 6s1",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  56: {
    electronConfiguration: "[Xe] 6s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  57: {
    sourceNotes: {
      electronConfiguration: "v2.9 limited electron-configuration batch covering elements 55–86; lanthanide/heavy-element configurations may vary by source notation and should be verified before being treated as authoritative."
    },
    electronConfiguration: "[Xe] 5d1 6s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  58: {
    sourceNotes: {
      electronConfiguration: "v2.9 limited electron-configuration batch covering elements 55–86; lanthanide/heavy-element configurations may vary by source notation and should be verified before being treated as authoritative."
    },
    electronConfiguration: "[Xe] 4f1 5d1 6s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  59: {
    electronConfiguration: "[Xe] 4f3 6s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  60: {
    electronConfiguration: "[Xe] 4f4 6s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  61: {
    electronConfiguration: "[Xe] 4f5 6s2",
    phaseAtSTP: "solid",
    occurrence: "synthetic",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  62: {
    electronConfiguration: "[Xe] 4f6 6s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  63: {
    sourceNotes: {
      electronConfiguration: "v2.9 limited electron-configuration batch covering elements 55–86; lanthanide/heavy-element configurations may vary by source notation and should be verified before being treated as authoritative."
    },
    electronConfiguration: "[Xe] 4f7 6s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  64: {
    sourceNotes: {
      electronConfiguration: "v2.9 limited electron-configuration batch covering elements 55–86; lanthanide/heavy-element configurations may vary by source notation and should be verified before being treated as authoritative."
    },
    electronConfiguration: "[Xe] 4f7 5d1 6s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  65: {
    electronConfiguration: "[Xe] 4f9 6s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  66: {
    electronConfiguration: "[Xe] 4f10 6s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  67: {
    electronConfiguration: "[Xe] 4f11 6s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  68: {
    electronConfiguration: "[Xe] 4f12 6s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  69: {
    electronConfiguration: "[Xe] 4f13 6s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  70: {
    sourceNotes: {
      electronConfiguration: "v2.9 limited electron-configuration batch covering elements 55–86; lanthanide/heavy-element configurations may vary by source notation and should be verified before being treated as authoritative."
    },
    electronConfiguration: "[Xe] 4f14 6s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  71: {
    sourceNotes: {
      electronConfiguration: "v2.9 limited electron-configuration batch covering elements 55–86; lanthanide/heavy-element configurations may vary by source notation and should be verified before being treated as authoritative."
    },
    electronConfiguration: "[Xe] 4f14 5d1 6s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  72: {
    electronConfiguration: "[Xe] 4f14 5d2 6s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  73: {
    electronConfiguration: "[Xe] 4f14 5d3 6s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  74: {
    electronConfiguration: "[Xe] 4f14 5d4 6s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  75: {
    electronConfiguration: "[Xe] 4f14 5d5 6s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  76: {
    electronConfiguration: "[Xe] 4f14 5d6 6s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  77: {
    electronConfiguration: "[Xe] 4f14 5d7 6s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  78: {
    sourceNotes: {
      electronConfiguration: "v2.9 limited electron-configuration batch covering elements 55–86; lanthanide/heavy-element configurations may vary by source notation and should be verified before being treated as authoritative."
    },
    electronConfiguration: "[Xe] 4f14 5d9 6s1",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  79: {
    sourceNotes: {
      electronConfiguration: "v2.9 limited electron-configuration batch covering elements 55–86; lanthanide/heavy-element configurations may vary by source notation and should be verified before being treated as authoritative."
    },
    electronConfiguration: "[Xe] 4f14 5d10 6s1",
    atomicMass: 196.96657,
    electronegativity: 2.54,
    ionization: 9.226,
    density: 19.32,
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      atomicMass: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    },
    stable: true,
    discovered: -6000
  },
  80: {
    electronConfiguration: "[Xe] 4f14 5d10 6s2",
    phaseAtSTP: "liquid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  81: {
    electronConfiguration: "[Xe] 4f14 5d10 6s2 6p1",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  82: {
    electronConfiguration: "[Xe] 4f14 5d10 6s2 6p2",
    atomicMass: 207.2,
    electronegativity: 2.33,
    ionization: 7.417,
    density: 11.34,
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      atomicMass: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    },
    stable: true,
    discovered: -7000
  },
  83: {
    electronConfiguration: "[Xe] 4f14 5d10 6s2 6p3",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  84: {
    electronConfiguration: "[Xe] 4f14 5d10 6s2 6p4",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  85: {
    electronConfiguration: "[Xe] 4f14 5d10 6s2 6p5",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  86: {
    sourceNotes: {
      electronConfiguration: "v2.9 limited electron-configuration batch covering elements 55–86; lanthanide/heavy-element configurations may vary by source notation and should be verified before being treated as authoritative."
    },
    electronConfiguration: "[Xe] 4f14 5d10 6s2 6p6",
    phaseAtSTP: "gas",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  87: {
    electronConfiguration: "[Rn] 7s1",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  88: {
    electronConfiguration: "[Rn] 7s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  89: {
    sourceNotes: {
      electronConfiguration: "v3.0 electron-configuration completion batch covering elements 87–118; actinide/superheavy configurations may vary by source notation or model and should be verified before being treated as authoritative."
    },
    electronConfiguration: "[Rn] 6d1 7s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  90: {
    electronConfiguration: "[Rn] 6d2 7s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  91: {
    sourceNotes: {
      electronConfiguration: "v3.0 electron-configuration completion batch covering elements 87–118; actinide/superheavy configurations may vary by source notation or model and should be verified before being treated as authoritative."
    },
    electronConfiguration: "[Rn] 5f2 6d1 7s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  92: {
    sourceNotes: {
      electronConfiguration: "v3.0 electron-configuration completion batch covering elements 87–118; actinide/superheavy configurations may vary by source notation or model and should be verified before being treated as authoritative."
    },
    electronConfiguration: "[Rn] 5f3 6d1 7s2",
    atomicMass: 238.02891,
    electronegativity: 1.38,
    ionization: 6.194,
    density: 19.1,
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      atomicMass: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    },
    stable: false,
    discovered: 1789
  },
  93: {
    electronConfiguration: "[Rn] 5f4 6d1 7s2",
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  94: {
    sourceNotes: {
      electronConfiguration: "v3.0 electron-configuration completion batch covering elements 87–118; actinide/superheavy configurations may vary by source notation or model and should be verified before being treated as authoritative."
    },
    electronConfiguration: "[Rn] 5f6 7s2",
    atomicMass: 244,
    electronegativity: 1.28,
    ionization: 6.026,
    density: 19.86,
    phaseAtSTP: "solid",
    occurrence: "natural",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      atomicMass: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    },
    stable: false,
    discovered: 1940
  },
  95: {
    electronConfiguration: "[Rn] 5f7 7s2",
    phaseAtSTP: "solid",
    occurrence: "synthetic",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  96: {
    sourceNotes: {
      electronConfiguration: "v3.0 electron-configuration completion batch covering elements 87–118; actinide/superheavy configurations may vary by source notation or model and should be verified before being treated as authoritative."
    },
    electronConfiguration: "[Rn] 5f7 6d1 7s2",
    phaseAtSTP: "solid",
    occurrence: "synthetic",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  97: {
    electronConfiguration: "[Rn] 5f9 7s2",
    phaseAtSTP: "solid",
    occurrence: "synthetic",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  98: {
    electronConfiguration: "[Rn] 5f10 7s2",
    phaseAtSTP: "solid",
    occurrence: "synthetic",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  99: {
    electronConfiguration: "[Rn] 5f11 7s2",
    phaseAtSTP: "solid",
    occurrence: "synthetic",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  100: {
    electronConfiguration: "[Rn] 5f12 7s2",
    phaseAtSTP: "solid",
    occurrence: "synthetic",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  101: {
    electronConfiguration: "[Rn] 5f13 7s2",
    phaseAtSTP: "solid",
    occurrence: "synthetic",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  102: {
    electronConfiguration: "[Rn] 5f14 7s2",
    phaseAtSTP: "solid",
    occurrence: "synthetic",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  103: {
    sourceNotes: {
      electronConfiguration: "v3.0 electron-configuration completion batch covering elements 87–118; actinide/superheavy configurations may vary by source notation or model and should be verified before being treated as authoritative."
    },
    electronConfiguration: "[Rn] 5f14 7s2 7p1",
    phaseAtSTP: "solid",
    occurrence: "synthetic",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  104: {
    electronConfiguration: "[Rn] 5f14 6d2 7s2",
    phaseAtSTP: "solid",
    occurrence: "synthetic",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  105: {
    electronConfiguration: "[Rn] 5f14 6d3 7s2",
    phaseAtSTP: "solid",
    occurrence: "synthetic",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  106: {
    electronConfiguration: "[Rn] 5f14 6d4 7s2",
    phaseAtSTP: "solid",
    occurrence: "synthetic",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  107: {
    electronConfiguration: "[Rn] 5f14 6d5 7s2",
    phaseAtSTP: "solid",
    occurrence: "synthetic",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  108: {
    electronConfiguration: "[Rn] 5f14 6d6 7s2",
    phaseAtSTP: "solid",
    occurrence: "synthetic",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  109: {
    electronConfiguration: "[Rn] 5f14 6d7 7s2",
    phaseAtSTP: "solid",
    occurrence: "synthetic",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  110: {
    electronConfiguration: "[Rn] 5f14 6d8 7s2",
    phaseAtSTP: "solid",
    occurrence: "synthetic",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  111: {
    electronConfiguration: "[Rn] 5f14 6d9 7s2",
    phaseAtSTP: "solid",
    occurrence: "synthetic",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  112: {
    sourceNotes: {
      electronConfiguration: "v3.0 electron-configuration completion batch covering elements 87–118; actinide/superheavy configurations may vary by source notation or model and should be verified before being treated as authoritative."
    },
    electronConfiguration: "[Rn] 5f14 6d10 7s2",
    phaseAtSTP: "solid",
    occurrence: "synthetic",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  113: {
    sourceNotes: {
      electronConfiguration: "v3.0 electron-configuration completion batch covering elements 87–118; actinide/superheavy configurations may vary by source notation or model and should be verified before being treated as authoritative."
    },
    electronConfiguration: "[Rn] 5f14 6d10 7s2 7p1",
    phaseAtSTP: "solid",
    occurrence: "synthetic",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  114: {
    sourceNotes: {
      electronConfiguration: "v3.0 electron-configuration completion batch covering elements 87–118; actinide/superheavy configurations may vary by source notation or model and should be verified before being treated as authoritative."
    },
    electronConfiguration: "[Rn] 5f14 6d10 7s2 7p2",
    phaseAtSTP: "solid",
    occurrence: "synthetic",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  115: {
    electronConfiguration: "[Rn] 5f14 6d10 7s2 7p3",
    phaseAtSTP: "solid",
    occurrence: "synthetic",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  116: {
    electronConfiguration: "[Rn] 5f14 6d10 7s2 7p4",
    phaseAtSTP: "solid",
    occurrence: "synthetic",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  117: {
    electronConfiguration: "[Rn] 5f14 6d10 7s2 7p5",
    phaseAtSTP: "solid",
    occurrence: "synthetic",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    }
  },
  118: {
    sourceNotes: {
      electronConfiguration: "v3.0 electron-configuration completion batch covering elements 87–118; actinide/superheavy configurations may vary by source notation or model and should be verified before being treated as authoritative."
    },
    electronConfiguration: "[Rn] 5f14 6d10 7s2 7p6",
    atomicMass: 294,
    electronegativity: null,
    ionization: null,
    density: null,
    phaseAtSTP: null,
    occurrence: "synthetic",
    sourceRefs: {
      electronConfiguration: [
        "rsc",
        "pubchem"
      ],
      atomicMass: [
        "iupac",
        "rsc",
        "pubchem"
      ],
      phaseAtSTP: [
        "rsc",
        "pubchem"
      ],
      occurrence: [
        "iupac",
        "rsc",
        "pubchem"
      ]
    },
    stable: false,
    discovered: 2002
  },
  119: {
    electronConfiguration: null,
    phaseAtSTP: null,
    occurrence: "future-unconfirmed"
  },
  120: {
    electronConfiguration: null,
    phaseAtSTP: null,
    occurrence: "future-unconfirmed"
  }
};
